import React, { Component, type ErrorInfo, type ReactNode } from 'react';
type QualificationErrorBoundaryProps = {
  children: ReactNode;
};
type QualificationErrorBoundaryState = {
  hasError: boolean;
};
export class QualificationErrorBoundary extends Component<QualificationErrorBoundaryProps, QualificationErrorBoundaryState> {
  state: QualificationErrorBoundaryState = {
    hasError: false
  };
  static getDerivedStateFromError(): QualificationErrorBoundaryState {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Error en el formulario de cualificación:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return <section id="calificar" className="border-t border-white/10 bg-ink-900 px-4 py-20 sm:px-6" data-id="element-79" data-mp="1rnilrmh8cvb9">
          <div className="mx-auto max-w-xl rounded-2xl border border-white/10 bg-ink-850 p-8 text-center" data-id="element-80" data-mp="3h49uephkh2mg">
            <h2 className="mb-3 text-2xl font-semibold text-white" data-id="element-81" data-mp="3m1jjg411nc9r">
              No pudimos cargar la evaluación
            </h2>
            <p className="mb-7 text-white/75" data-id="element-82" data-mp="1w34o6n2u37rw">
              Actualiza la página para intentarlo nuevamente. Tus respuestas no
              se enviaron.
            </p>
            <button type="button" onClick={() => window.location.reload()} className="rounded-lg bg-gold px-6 py-3 font-semibold text-black transition-colors duration-200 hover:bg-gold-light" data-id="element-83" data-mp="24x9n7ts4fpii">
              Actualizar página
            </button>
          </div>
        </section>;
    }
    return this.props.children;
  }
}